import { examResultsEndpoints } from "@/constants";
import { LanguageEnum } from "@/enums";
import { axiosClient } from "@/services/axios-client";
import { transformApiRecommendedJobHandler } from "@/services/shared";
import type { ApiExamStatusEnvelopeType, ExamStatusResponseType } from "@/types";

export const getExamStatusHandler = async (jobId: string, lang?: string): Promise<ExamStatusResponseType> => {
    const url = lang === LanguageEnum.AR ? `${examResultsEndpoints.status(jobId)}?lang=${LanguageEnum.AR}` : examResultsEndpoints.status(jobId);

    const headers = lang === LanguageEnum.AR ? { "Accept-Language": LanguageEnum.AR } : undefined;

    const response = await axiosClient.get<ApiExamStatusEnvelopeType>(
        url,
        { headers },
    );

    const { data } = response.data;

    return {
        completedAt: data.completed_at,
        currentStep: data.current_step,
        displayProgress: data.display_progress ?? data.progress,
        displayProgressIsEstimated: data.display_progress_is_estimated ?? false,
        errorMessage: data.error_message,
        progress: data.progress,
        result: data.result
            ? {
                recommendedJobs: data.result.recommended_jobs?.map(transformApiRecommendedJobHandler),
            }
            : null,
        startedAt: data.started_at,
        status: data.status,
    };
};
